import React, { useEffect, useState } from 'react';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';

import NavPills from 'components/NavPills/NavPills.js';

import Provider from './GroupListSell/Provider';
import Category from './GroupListSell/Category';
import Product from './GroupListSell/Product';
import Family from './GroupListSell/Family';

import { wsFindBy, wsRemove, wsCreate, wsUpdate } from 'services/WService.js';

import ValueSellGroup from './ValueSellGroup';

import GroupSaleProduct from './GroupSale/GroupSaleProduct';
import GroupSaleProvider from './GroupSale/GroupSaleProvider';
import GroupSaleCategory from './GroupSale/GroupSaleCategory';
import GroupSaleFamily from './GroupSale/GroupSaleFamily';

export default function SellGroup(props) {
  const { rule, showNotify } = props;

  const promo = props.promotion;
  const statePromo = promo.state == 'N' || promo.state == 'G' ? false : true;

  //#region  estado para listados de filtros --
  const [providers, setProviders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [families, setFamilies] = useState([]);

  async function listProviders() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setProviders(response.data);
  }

  async function listCategories(provider_id) {
    let response = await wsFindBy('logi/category', 'base_business_partner_id', provider_id);
    if (response.success) setCategories(response.data);
  }

  async function listFamilies(category_id) {
    let response = await wsFindBy('logi/family', 'logi_category_id', category_id);
    if (response.success) setFamilies(response.data);
  }
  //#endregion

  const [sellGroups, setSellGroups] = useState([]);

  const [currentSellGroup, setCurentSellGroup] = useState({ index: 0, id: 0 });

  async function listSellGroups() {
    let [groupResponse, productsResponse] = await Promise.all([
      wsFindBy('prom/product-group', 'prom_rule_id', rule.id),
      wsFindBy('prom/product', 'prom_rule_id', rule.id),
    ]);
    if (groupResponse.success && productsResponse.success) {
      for (let i = 0; i < groupResponse.data.length; i++) {
        groupResponse.data[i].products = productsResponse.data.filter((product) => {
          return product.prom_product_group_id == groupResponse.data[i].id;
        });
      }
      if (groupResponse.data.length > 0) {
        let id = groupResponse.data[0].id;
        setCurentSellGroup({ index: 0, id });
        props.setCurrentSellGroup(true); //callback de esto para borrar o no
      } else {
        setCurentSellGroup({ index: 0, id: 0 });
      }
      setSellGroups(groupResponse.data);
    }
  }

  async function deleteSellProduct(product) {
    let response = await wsRemove('prom/product', product.id);
    if (response.success) {
      listSellProducts(product.prom_product_group_id);
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function listSellProducts(sellGroupId) {
    let response = await wsFindBy('prom/product', 'prom_product_group_id', sellGroupId);
    if (response.success) {
      let newSellGroups = sellGroups.map((group) => {
        if (group.id == sellGroupId) {
          group.products = response.data;
        }
        return group;
      });
      setSellGroups(newSellGroups);
    }
  }

  async function addSellGroup() {
    if (!!rule) {
      let response = await wsCreate('prom/product-group', {
        prom_rule_id: rule.id,
        prom_promotion_id: rule.prom_promotion_id,
        discount: 0, // En caso si el tipo bonificacion es de tipo descuento
        base_business_partner_id: promo.base_business_partner_id, // Proveedor // si no esta indicado arriba tiene que ser el de la misma empresa
        // base_bureau_id: '', // Mesa
        // logi_category_id: '', // Categoria Dependiendo del Tipo de evaluacion
        // logi_family_id: '', // Familia Dependiendo del Tipo de evaluacion
        quantity_group: 0, // La cantidad de productos total, defecto 0?
      });

      if (response.success) {
        response.data.products = [];
        setSellGroups([...sellGroups, response.data]);
        setCurentSellGroup({
          id: response.data.id,
          index: 0,
        });
        props.setCurrentSellGroup(true); //callback de esto para borrar o no
      } else {
        showNotify(response.message, 'error');
      }
    } else {
      showNotify('Primero seleccione una regla', 'info');
    }
  }

  function verifyItemExists(item) {
    let key = '';
    switch (promo.evaluation_type) {
      case 'P':
        key = 'ItemCode';
        break;
      case 'S':
        key = 'CardCode';
        break;
      case 'C':
      case 'F':
        key = 'code';
        break;
    }
    for (let sellGroup of sellGroups) {
      let product = sellGroup.products.find((itemInGroup) => {
        return itemInGroup.item_code == item[key];
      });
      if (product !== undefined) {
        return true;
      }
    }
    return false;
  }

  async function addProduct(product) {
    if (verifyItemExists(product)) {
      showNotify('Producto ya esta agregado', 'info');
      return;
    }

    if (currentSellGroup.id == 0) {
      showNotify('Cree un grupo de Venta', 'info');
      return;
    }

    let item = {
      prom_product_group_id: currentSellGroup.id,
      required: '0',
    };

    switch (promo.evaluation_type) {
      case 'P':
        item.logi_product_id = product.id;
        break;
      case 'S':
        item.base_business_partner_id = product.id;
        break;
      case 'C':
        item.logi_category_id = product.id;
        break;
      case 'F':
        item.logi_family_id = product.id;
        break;
    }

    let response = await wsCreate('prom/product', item);
    if (response.success) {
      listSellProducts(currentSellGroup.id);
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function updateSaleProduct(productId, valueRequired) {
    const response = await wsUpdate('prom/product', productId, { required: valueRequired });
    if (response.success) {
      listSellProducts(currentSellGroup.id);
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listProviders();
    listCategories(promo.base_business_partner_id);
  }, [promo]);

  useEffect(() => {
    if (!!rule) {
      listSellGroups();
    }
  }, [rule]);

  return (
    <div>
      {statePromo == false ? (
        <GridItem xs={12}>
          {promo.evaluation_type === 'P' ? (
            <Product
              promo={promo}
              providers={providers}
              categories={categories}
              listCategories={listCategories}
              listFamilies={listFamilies}
              setCategories={setCategories}
              setFamilies={setFamilies}
              families={families}
              addProduct={addProduct}
            />
          ) : promo.evaluation_type === 'S' ? (
            <Provider addProduct={addProduct} promo={promo} />
          ) : promo.evaluation_type === 'C' ? (
            <Category providers={providers} addProduct={addProduct} promo={promo} />
          ) : (
            <Family
              providers={providers}
              categories={categories}
              listCategories={listCategories}
              setCategories={setCategories}
              addProduct={addProduct}
              promo={promo}
            />
          )}
        </GridItem>
      ) : undefined}

      <GridItem xs={12}>
        <hr />
        <h4
          style={{
            textAlign: 'center',
            fontWeight: 'bold',
            textDecoration: 'underline',
          }}
        >
          Grupos de venta de la regla # {!!rule ? rule.id : '...'}
        </h4>

        <Button disabled={statePromo} onClick={addSellGroup}>
          Nuevo grupo
        </Button>
        <NavPills
          color="primary"
          active={currentSellGroup.index}
          setActive={(index) => {
            setCurentSellGroup({
              id: sellGroups[index].id,
              index,
            });
          }}
          horizontal={{
            tabsGrid: { xs: 12, lg: 4 },
            contentGrid: { xs: 12, lg: 8 },
          }}
          tabs={sellGroups.map((sellGroup, i) => {
            return {
              tabButton: `Grupo ${i + 1}`,
              tabContent: (
                <div>
                  <GridItem xs={12}>
                    <ValueSellGroup
                      rule={rule}
                      grupo={i + 1}
                      sellGroup={sellGroup}
                      reload={listSellGroups}
                      promo={promo}
                      showNotify={showNotify}
                      reloadPromoGeneral={props.reloadPromo}
                      confirmDeleteGroup={props.confirmDeleteGroup}
                    />
                  </GridItem>
                  <GridItem xs={12} style={{ maxHeight: '500px', overflow: 'auto' }}>
                    <GroupSaleProduct
                      sellGroup={sellGroup}
                      deleteSellProduct={deleteSellProduct}
                      updateSaleProduct={updateSaleProduct}
                      statePromo={statePromo}
                    />
                  </GridItem>
                </div>
              ),
            };
          })}
        />
      </GridItem>
    </div>
  );
}
